import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/smartportalapp/app/components/GlobalErrorHandlerInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/smartportalapp/app/components/PaymentReturnBoundary.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/smartportalapp/app/components/PerformanceDashboard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/smartportalapp/app/components/PerformanceMonitor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/var/www/smartportalapp/app/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/var/www/smartportalapp/app/contexts/LanguageContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PerformanceProvider"] */ "/var/www/smartportalapp/app/contexts/PerformanceContext.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/smartportalapp/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/smartportalapp/app/navigation/NavigationProgressBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationProvider"] */ "/var/www/smartportalapp/app/notifications/NotificationProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/smartportalapp/components/auth/AuthWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/smartportalapp/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContainer"] */ "/var/www/smartportalapp/node_modules/react-toastify/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/smartportalapp/node_modules/react-toastify/dist/ReactToastify.css");
